import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { BRAND } from './insights/agencyChartTheme';

const useStyles = createUseStyles({
    panel: {
        borderRadius: 12,
        border: `1px solid ${BRAND.tealEdge}`,
        background: 'var(--ion-background-color)'
    },

    clipped: {
        overflow: 'hidden'
    },

    // The Ask Bea card's header inset, so panels stacked under it line up with it.
    head: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '14px 16px 10px'
    },

    title: {
        fontSize: 16,
        fontWeight: 700
    },

    detail: {
        marginTop: 1,
        fontSize: 12.5,
        color: 'var(--ion-color-step-600)'
    }
});

/** The frame the insights reports and the agency home's panels share, so they read as one product. */
export const AgencyPanel: FC<{
    'data-type'?: string;
    /** For content that would otherwise spill past the rounded border, such as an Ionic list's background. */
    clip?: boolean;
    children: ReactNode;
}> = ({ 'data-type': dataType, clip, children }) => {
    const classes = useStyles();

    return <div className={`${classes.panel}${clip ? ` ${classes.clipped}` : ''}`} data-type={dataType}>{children}</div>;
};

/** A panel's title, with an optional line under it and the panel's one action at the far end. */
export const AgencyPanelHead: FC<{ title: string; detail?: string; action?: ReactNode }> = ({ title, detail, action }) => {
    const classes = useStyles();

    return (
        <div className={classes.head}>
            <div>
                <div className={classes.title}>{title}</div>
                {detail && <div className={classes.detail}>{detail}</div>}
            </div>
            {action}
        </div>
    );
};
